










































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component({
    components: {
        DatePicker,
    },
    computed: {
        ...mapGetters({
            allCountries: 'Properties/allCountries',
        }),
    },
})
export default class TenantPersonalPanel extends Mixins(InputFieldMethods, LocalizationMethods) {
    constructor() {
        super();
    }

    get errorCollection() {
        return this.errors.any();
    }

    get currentTenant() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'];
    }

    public savePersonalChanges() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                const tenanat = this.currentTenant;
                const data = {
                    id: tenanat.id,
                    name: tenanat.first_name,
                    lastName: tenanat.family_name,
                    birthday: tenanat.birthday,
                    email: tenanat.email,
                    phoneNumber: tenanat.phone_number,
                    nationality: tenanat.nationality,
                    gender: tenanat.gender,
                };

                this.$store.dispatch(Actions.SAVE_PERSONAL_CHANGES, data);
            }
        });
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_COUNTRIES);
    }
}
